import React from "react";
import { getLinkImageSrc } from "../../utils/url";

interface ClientLogoImageProps {
  className?: string;
  clientCode: string;
  imageFilename: string;
  alt?: string;
}

const ClientLogoImage = (props: ClientLogoImageProps) => {
  return <img className={`w-100 m-auto ${props.className}`} src={getLinkImageSrc(props.imageFilename, props.clientCode)} alt={props.alt} />;
};

export default ClientLogoImage;
